import { SET_CALLING_USER } from '../action-creators/buddyCall'

export const setCallingUser = (user) => ({ type: SET_CALLING_USER, user })
